// AUTO-GENERATED by sync-icons — do not edit.
import type { FC, SVGProps } from 'react';
const SvgClipboardIcon: FC<SVGProps<SVGGElement>> = props => (
  <g {...props}>
    <path d="M13 2a1 1 0 0 1 1 1v1h-4V3a1 1 0 0 1 1-1z" />
    <path d="M17 3a2 2 0 0 1 2 2v15a2 2 0 0 1-2 2H7a2 2 0 0 1-2-2V5a2 2 0 0 1 2-2h1v2a1 1 0 0 0 1 1h6a1 1 0 0 0 1-1V3z" />
    <path d="M14 3v1h-4V3z" />
  </g>
);
export default SvgClipboardIcon;
SvgClipboardIcon.displayName = 'SvgClipboardIcon';
